import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Programs from "@/components/site/Programs";
import Impact from "@/components/site/Impact";
import Events from "@/components/site/Events";
import Donate from "@/components/site/Donate";
import Forms from "@/components/site/Forms";
import Footer from "@/components/site/Footer";
import Pantry from "@/components/site/Pantry";
import PaymentResult from "@/pages/PaymentResult";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ProgramDetail from "@/pages/ProgramDetail";
import PastEvents from "@/pages/PastEvents";
import EventGallery from "@/pages/EventGallery";
import UpcomingEvents from "@/pages/UpcomingEvents";
import { LanguageProvider } from "@/i18n/LanguageContext";

const Home = () => (
  <main>
    <Hero />
    <Marquee />
    <Manifesto />
    <Programs />
    <Impact />
    <Events />
    <Pantry />
    <Donate />
    <Forms />
  </main>
);

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 400);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
    <div className="grain bg-[#FAF9F6] text-[#1A2F24]">
      <BrowserRouter>
        <ScrollManager />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/programs/:slug" element={<ProgramDetail />} />
          <Route path="/events" element={<UpcomingEvents />} />
          <Route path="/past-events" element={<PastEvents />} />
          <Route path="/past-events/:id" element={<EventGallery />} />
          <Route path="/payment/success" element={<PaymentResult kind="success" />} />
          <Route path="/payment/cancel" element={<PaymentResult kind="cancel" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
    </LanguageProvider>
  );
}

export default App;
